export default __webpack_public_path__ + "static/media/telegram.b9824e0b.svg";